import { render, staticRenderFns } from "./invoiceTitle.vue?vue&type=template&id=5dcbe6b8&scoped=true"
import script from "./invoiceTitle.vue?vue&type=script&lang=js"
export * from "./invoiceTitle.vue?vue&type=script&lang=js"
import style0 from "./invoiceTitle.vue?vue&type=style&index=0&id=5dcbe6b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcbe6b8",
  null
  
)

export default component.exports